import { CornSchema } from '@eigtech/shared-corn';
import { z } from 'zod';
import { InvoiceSchema } from '../base/index.js';
export const ReadInvoicesByEntityApiSchema = {
    params: z.object({
        entityId: CornSchema,
    }),
    response: z.object({ invoices: InvoiceSchema.array() }),
};
export const ReadInvoicesByEntityPathSchema = ReadInvoicesByEntityApiSchema.params;
export const ReadInvoicesByEntityRequestSchema = ReadInvoicesByEntityPathSchema;
export const ReadInvoicesByEntityResponseSchema = ReadInvoicesByEntityApiSchema.response;
